<template>
	<div class="container">
		<div class="empty" v-if="swipeList.length<1&&loading">
			<img src="../assets/images/no-data.png" alt="">
			<div class="empty-text">暂无数据</div>
			<div class="empty-text">持续佩戴手表将自动生成数据</div>
		</div>
		<van-swipe class="my-swipe" indicator-color="white" @change="onChange">
			<van-swipe-item v-for="(item,index) in swipeList" :key="index">
				<div style="min-height: 600px;color: #FFFFFF;width: 355px;margin: 0 auto;">
					<div style="display: block;text-align: left;color: #08070E;">
						<div style="padding-top: 48px;padding-left: 5px;font-size: 18px;">{{datestr}}</div>
						<div style="padding-top: 20px;padding-left: 5px;padding-bottom: 58px;">{{item.str}}</div>
					</div>
					<div class="datemotionBj html2canvas" >
						<div class="dateimgmain" :style="{backgroundImage:'url(https://www.qingxusuanfa.com/public/'+item.img+')'}">
							<div class="emocontent">
								<h3 style="font-size: 24px;font-weight: 500;line-height: 18px;letter-spacing: 2px;">最常见的状态
								</h3>
								<h1 style="font-size: 28px;line-height: 18px;margin-top: 34px;">
									“{{formatEmo(dayMean[indexType]).str}}”</h1>
								<div
									style="width: 85%;margin: 0 auto;font-weight: 500;margin-top: 31px;font-size: 18px;line-height: 29px;">
									<p style="">
										共计{{parseInt(dayEmotionTimeln*60*dayPercent[indexType][0]/100/60)}}小时{{parseInt((dayEmotionTimeln*60*dayPercent[indexType][0]/100/60-parseInt(dayEmotionTimeln*60*dayPercent[indexType][0]/100/60))*60)==0?'':parseInt((dayEmotionTimeln*60*dayPercent[indexType][0]/100/60-parseInt(dayEmotionTimeln*60*dayPercent[indexType][0]/100/60))*60)+'分钟'}},占比{{dayPercent[indexType][0]}}%
									</p>
									<p v-if="predayMean[indexType]">
										占比相较昨天{{dayMean[indexType]>=predayMean[indexType]?'上升':'下降'}}{{contrastDay()}}%
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-swipe-item>
			<van-swipe-item v-if="affectTag">
				<div style="min-height: 600px;color: #FFFFFF;width: 355px;margin: 0 auto;">
					<div style="display: block;text-align: left;color: #08070E;">
						<div style="padding-top: 48px;padding-left: 5px;font-size: 18px;">{{datestr}}</div>
						<div style="padding-top: 20px;padding-left: 5px;padding-bottom: 58px;">今日情绪关键词</div>
					</div>
					<div class="datemotionBj html2canvas">
						<div class="dateimgmain" :style="{backgroundImage:'url(https://www.qingxusuanfa.com/public/'+affectImg+')'}">
						<div class="emocontent">
							<h3 style="font-size: 24px;font-weight: 500;line-height: 45px;letter-spacing: 2px;">
								“{{affectTag}}”
							</h3>
							<h1 style="font-size: 28px;line-height: 45px;"></h1>
							<div
								style="width: 85%;margin: 0 auto;font-weight: 500;text-align: left;line-height: 32px;text-indent: 2em;">
								<p class="p-white">
									{{affectStr}}
								</p>
							</div>
						</div>
						</div>
					</div>
				</div>
			</van-swipe-item>
			<van-swipe-item v-if="showdayMean">
				<div style="min-height: 600px;color: #FFFFFF;width: 355px;margin: 0 auto;">
					<div style="display: block;text-align: left;color: #08070E;">
						<div style="padding-top: 48px;padding-left: 5px;font-size: 18px;">{{datestr}}</div>
						<div style="padding-top: 20px;padding-left: 5px;padding-bottom: 58px;">情绪稳定性</div>
					</div>
					<div class="datemotionBj html2canvas">
						<div class="dateimgmain" style="background-image:url(https://www.qingxusuanfa.com/public/emobj6.png);">
						<div class="emocontent" style="padding-top: 75px;">
<!-- 							<h3 style="font-size: 24px;font-weight: 500;line-height: 45px;letter-spacing: 2px;">最常见的状态
							</h3> -->
							<h1 style="font-size: 28px;line-height: 45px;"></h1>
							<div class="emowd"
								style="width: 85%;margin: 0 auto;font-weight: 500;text-align: left;line-height: 32px;">
								<div v-if="emoStable<=15" class="p-black">
									今日心情指数<font style="color: #0DCAC3;">较为稳定</font>
								</div>
								<div v-else-if="emoStable>=30" class="p-black">
									今日心情指数<font style="color: #d9687b;">波动较大</font>
								</div>
								<div v-else class="p-black">
									今日心情指数<font style="color: #0DCAC3;">略有波动</font>
								</div>
								<div v-if="emoup.length>=2" class="p-minb">
									在{{emoup[0].hour}}:00-{{emoup[emoup.length-1].hour}}:00这段时间里您的心情愉悦，看来在这几个小时里发生了美好的事情呢~
								</div>
								<div v-else-if="emodn.length>=2" class="p-minb">
									在{{emodn[0].hour}}:00-{{emodn[emodn.length-1].hour}}:00这段时间里您的心情指数达到了{{emodn[emodn.length-1].emotion}}，这个时刻您可能正遇到一些棘手的困难和压力事
								</div>
								<div v-if="strStable<=15" class="p-black">
									今日压力指数<font style="color: #0DCAC3;">较为稳定</font>
								</div>
								<div v-else-if="strStable>=30" class="p-black">
									今日压力指数<font style="color: #d9687b;">波动较大</font>
								</div>
								<div v-else class="p-black">
									今日压力指数<font style="color: #0DCAC3;">略有波动</font>
								</div>
								<div v-if="strup.length>=2" class="p-minb">
									在{{strup[0].hour}}:00-{{strup[strup.length-1].hour}}:00这段时间里您感到放松，看来这段时间工作会比较轻松，生活中也没有让您感到为难的场景。
								</div>
								<div v-else-if="strdn.length>=2" class="p-minb">
									在{{strdn[0].hour}}:00-{{strdn[strdn.length-1].hour}}:00这段时间里您压力较大，可能发生了令你感到紧张或兴奋的事情。
								</div>
								<div v-if="triStable<=15" class="p-black">
									今日疲劳指数<font style="color: #0DCAC3;">较为稳定</font>
								</div>
								<div v-else-if="triStable>=30" class="p-black">
									今日疲劳指数<font style="color: #d9687b;">波动较大</font>
								</div>
								<div v-else class="p-black">
									今日疲劳指数<font style="color: #0DCAC3;">略有波动</font>
								</div>
								<div v-if="triup.length>=2" class="p-mina">
									在{{triup[0].hour}}:00-{{triup[triup.length-1].hour}}:00这段时间里您精力充沛，说明这段时间您没有长时间进行令人感到精神紧张的脑力工作，大脑状态正好。
								</div>
								<div v-else-if="tridn.length>=2" class="p-mina">
									在{{tridn[0].hour}}:00-{{tridn[tridn.length-1].hour}}:00这段时间里您十分疲劳，可能当时所做的事情单调厌烦或学习工作过量。
								</div>
							</div>
						</div>
						</div>
					</div>
				</div>
			</van-swipe-item>
			<van-swipe-item v-if="showdayMean">
				<div style="min-height: 600px;color: #FFFFFF;width: 355px;margin: 0 auto;">
					<div style="display: block;text-align: left;color: #08070E;">
						<div style="padding-top: 48px;padding-left: 5px;font-size: 18px;">{{datestr}}</div>
						<div style="padding-top: 20px;padding-left: 5px;padding-bottom: 58px;">与其他人相比</div>
					</div>
					<div class="datemotionBj html2canvas ortherbj">
						<div class="dateimgmain"
							style="background-image: url(https://www.qingxusuanfa.com/public/emobj4.png);">
							<div class="emocontent" style="padding-top: 115px;">
								<div style="width: 85%;margin: 0 auto;font-weight: 500;text-align: left;">
									<div class="p-black">
										今日心情指数{{dayMean['emotion']}}，{{otherpass(dayMean['emotion'])}}%的人
									</div>
									<div class="p-min">
										{{dayMean['emotion']>=50?'心情愉悦，状态不错，请继续保持!':'和其他人比，当前心情可能不是很好，请及时调节！'}}
									</div>
									<div class="p-black">
										今日压力指数{{dayMean['stress']}}，{{otherpass(dayMean['stress'])}}%的人
									</div>
									<div class="p-min">
										{{dayMean['stress']>=50?'压力过大，可能发生了令你感到紧张或兴奋的事情，请注意调节。':'压力不大，轻松惬意。'}}
									</div>
									<div class="p-black">
										今日疲劳指数{{dayMean['tired']}}，{{otherpass(dayMean['tired'])}}%的人
									</div>
									<div class="p-mina">
										{{dayMean['tired']>=50?' 疲劳度较高，请注意休息！':'精力充沛，去做困难的事吧！'}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-swipe-item>
			<template #indicator>
				<div class="custom-indicator" v-if="loading&&swipeList.length>0">
					<div v-for="(item,index) in swipeDot" :key="index" :class="{active:item.active}"></div>
				</div>
			</template>
		</van-swipe>
<!-- 		<div v-if="swipeDot[swipeDot.length-1].active"
			style="display: flex;flex-direction: row;justify-content: space-between;height: 64px;position: fixed;bottom: 60px;width: 355px;">
			<div
				style="width: 150px;height: 64px;margin-left: 20px;font-size: 16px;font-weight: 500;color: #333333;line-height: 32px;">
				<p style="color:#000">彼岸心智</p>
				<p style="color:#000">扫码关注 识别情绪</p>
			</div>
			<img src="../assets/images/ewm.png" style="width: 64px;height: 64px;" />
		</div> -->
		<div v-if="swipeList.length>0" style="width: 90%;margin: 0 auto;position: absolute;bottom: 10px;left: 5%;">
			<van-button color="linear-gradient(130deg, #00C8BD 0%, #40D2DA 100%)" size="large" round type="info"
				@click="createimg()">分享本页
			</van-button>
		</div>
		<van-popup v-model="shareShow" round closeable close-icon-position="top-right" @close="closecanvas">
			<div>
				<img width="353" :src="imgSrc" />
			</div>
		</van-popup>
		<div style="width: 100%;margin-top: 500px;" v-show="popupc">
			<div style="width: 363px;margin: 0 auto;position: relative;background: linear-gradient(137deg, #E7FEFF 15%, #FFFFFF 100%);"  ref="ExportDiv">
				<div style="height: 1px;"></div>
				<div style="height: 78px;padding: 10px;width: 343px;margin: 15px auto 0;">
					<div style="float: left;width: 48px;height: 48px;">
						<img width="48" height="48" src="../assets/images/user-pic.png" alt="" class="user-pic">
					</div>
					<div style="float: left;margin: 5px;">
						<div style="font-size: 18px;color: #193231;font-weight: bold;">彼岸心智 {{nickname}}</div>
						<div style="font-size: 14px;font-weight: 500;color: #686A6A;">{{datestr}}</div>
					</div>
				</div>
				<div class="imgtitle">{{swipeListStr[current]}}</div>
				<div id="saveimg" v-html="vhtml" ref="saveimg" style="height: 400px;padding: 15px;text-align: center;margin-top:20px;position: relative;left: -5px;"></div>
				<div class="logoblock">
					<div class="logotxt">
						<div>彼岸心智</div>
						<div>扫码关注 识别情绪</div>
						<div style="font-size: 14px;color: #05CAC0;">长按图片保存</div>
					</div>
					<img src="../assets/images/ewm.png" style="width: 64px;height: 64px;" />
				</div>
				<div style="height: 5px;"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import html2canvas from 'html2canvas'
	import moment from 'moment'
	import wx from "weixin-js-sdk";
	import {
		wx_token,
		wx_sign
	} from '../api/wx'
	import {
		choice_day_data,
		data_tag,
		upload_tag
	} from "../api/my.js"
	import {
		Swipe,
		SwipeItem,
		Button,
		Overlay,
		Toast,
		Popup
	} from 'vant';
	export default {
		components: {
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem,
			[Button.name]: Button,
			[Overlay.name]: Overlay,
			[Popup.name]: Popup,
		},
		data() {
			return {
				swipeListStr:['今日心情','今日压力','今日疲劳','今日情绪关键词','今日情绪稳定性','与其他人相比'],
				popupc:false,
				imgSrc:"",
				vhtml: '',
				nickname: '',
				emoup: [],
				emodn: [],
				triup: [],
				tridn: [],
				strup: [],
				strdn: [],
				emoStable: 0,
				triStable: 0,
				strStable: 0,
				showdayMean: false,
				swipeDot: [{
					active: true
				}],
				ticket: '',
				seccesstr: '',
				urlstr: '',
				shareShow: false,
				datestr: '',
				swipeList: [],
				current: 0,
				checkType: 'day',
				indexShow: false,
				indexType: 'emotion',
				indexText: '心情指数',
				choiceDay: '',
				choiceDayTime: '',
				today: [],
				preday: [],
				dayMean: {},
				predayMean: {},
				dayPercent: {},
				dayPercentAll: {},
				curret: 0,
				loading: true,
				affectImg: '',
				affectStr: '',
				affectTag: "",
				querydata: '',
				dayEmotionTimeln: 0,
				timeOutEvent:0,
				loadingevent:null
			}
		},
		methods: {
			closecanvas() {
				this.$nextTick(() => {
					this.shareShow = false;
				})
			},
			createimgdata() {
				this.loadingevent = this.$toast.loading({
					duration: 0,
					message: '加载中...',
					forbidClick: true,
				})
				this.$nextTick(() => {
					html2canvas(this.$refs.ExportDiv, {
						useCORS: true
					}).then((canvas) => {
						this.loadingevent.clear();
						this.popupc = false;
						this.imgSrc = canvas.toDataURL('image/png');
						this.shareShow = true;
					})
				})
			},
			createimg() {
				let childen = document.getElementsByClassName('html2canvas');
				this.vhtml = childen[this.current].innerHTML;
				this.popupc = true;
				this.createimgdata();
			},
			otherpass(val) {
				if (val <= 60) {
					let v = Math.ceil(val * 0.83)
					if (v <= 49) {
						v = 100 - v
						return '低于' + v;
					}
					return '高于' + v;
				} else if (val > 60 && val <= 70) {

					let v = Math.ceil((val - 60) * 3) + 50;

					if (v <= 49) {
						v = 100 - v
						return '低于' + v;
					}
					return '高于' + v;
				} else if (val > 70 && val <= 80) {
					let v = Math.ceil((val - 70) * 1) + 80;
					if (v <= 49) {
						v = 100 - v
						return '低于' + v;
					}
					return '高于' + v;
				} else if (val > 80 && val <= 90) {
					let v = Math.ceil((val - 80) * 0.5) + 90;
					if (v <= 49) {
						v = 100 - v
						return '低于' + v;
					}
					return '高于' + v;
				} else if (val > 90 && val <= 100) {
					let v = Math.ceil((val - 90) * 0.5) + 95;
					if (v <= 49) {
						v = 100 - v
						return '低于' + v;
					}
					return '高于' + v;
				}
				return '0'
			},
			formatEmo(num) {
				if (this.indexType == 'emotion') {
					if (num <= 49) {
						return {
							str: '心情较差',
							img: 'emobj3',
							content: identifyTip(1, num)
						}
					}
					if (num >= 50 && num <= 69) {
						return {
							str: '心情一般',
							img: 'emobj5',
							content: '心情一般'
						}
					}
					if (num >= 70 && num <= 100) {
						return {
							str: '心情愉悦',
							img: 'emobj1',
							content: identifyTip(0, num)
						}
					}
				}
				if (this.indexType == 'tired') {
					if (num <= 49) {
						return {
							str: '精力充沛',
							img: 'emobj1',
							content: identifyTip(3, num)
						}
					}
					if (num >= 50 && num <= 69) {
						return {
							str: '有点疲惫',
							img: 'emobj2',
							content: '有点疲惫',
						}
					}
					if (num >= 70 && num <= 100) {
						return {
							str: '十分疲惫',
							img: 'emobj3',
							content: identifyTip(2, num)
						}
					}
				}
				if (this.indexType == 'stress') {
					if (num <= 49) {
						return {
							str: '十分轻松',
							img: 'emobj1',
							content: identifyTip(4, num)
						}
					}
					if (num >= 50 && num <= 69) {
						return {
							str: '稍有压力',
							img: 'emobj2',
							content: '稍有压力',
						}
					}
					if (num >= 70 && num <= 100) {
						return {
							str: '压力较大',
							img: 'emobj3',
							content: identifyTip(5, num)
						}
					}
				}
				return {};
			},
			onChange(i) {
				this.current = i
				let indexT = ['emotion', 'stress', 'tired']
				if (i < 3) this.indexType = indexT[i];
				for (let j in this.swipeDot) {
					this.swipeDot[j].active = false;
					if (i == j) {
						this.swipeDot[j].active = true;
					}
				}
			},
			contrastDay() {
				let preMean = this.predayMean[this.indexType]
				let todayMean = this.dayMean[this.indexType]
				let difEnd = null
				if (todayMean >= preMean) {
					let dif = (todayMean / preMean - 1) * 100
					difEnd = dif.toFixed(1)
				}
				if (todayMean < preMean) {
					let dif = (1 - todayMean / preMean) * 100
					difEnd = dif.toFixed(1)
				}
				return difEnd
			},
			wxshare() {
				wx_token().then(res => {
					let url = location.href.split('#')[0]
					this.urlstr = url + '/data=' + this.querydata
					this.ticket = res.data.ticket
					// this.copy()
					// wx_sign(res.data.ticket, url).then(res => {
					// 	console.log(res)
					// 	let this_ = this
					// 	if (res.status == 200) {
					// 		this.nonceStr = res.data.nonceStr;
					// 		this.signature = res.data.signature;
					// 		this.timestamp = res.data.timestamp;
					// 		wx.config({
					// 			// debug: true,
					// 			appId: 'wx4c3bbd3797c8de7d', // 必填，公众号的唯一标识
					// 			timestamp: this.timestamp, // 必填，生成签名的时间戳
					// 			nonceStr: this.nonceStr, // 必填，生成签名的随机串
					// 			signature: this.signature, // 必填，签名
					// 			jsApiList: [
					// 				'updateAppMessageShareData',
					// 				'updateTimelineShareData'
					// 			]
					// 		});
					// 		wx.ready(function() {
					// 			console.log('ready')
					// 			wx.updateAppMessageShareData({
					// 				title: "情绪日记",
					// 				desc: "情绪日记的分享",
					// 				link: this_.urlstr,
					// 				imgUrl: "https://www.qingxusuanfa.com/public/bixin.png",
					// 				type: 'link', // 分享类型,music、video或link，不填默认为link
					// 				// dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					// 				success: function(res) {
					// 					this_.seccesstr = 'success回调函数'
					// 				},
					// 			})
					// 			wx.updateTimelineShareData({
					// 				title: '情绪日记', // 分享标题
					// 				link: 'https://www.qingxusuanfa.com/#/usershare?data=' +
					// 					this_
					// 					.querydata, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
					// 				imgUrl: 'https://www.qingxusuanfa.com/public/bixin.png', // 分享图标
					// 				success: function() {
					// 					// 设置成功
					// 				}
					// 			})
					// 		});
					// 		wx.error(function(res) {
					// 			this_.seccesstr = 'error'
					// 			this_.wxshare()
					// 			console.log(res)
					// 		});
					// 	}
					// })
				})
			},
			getTag() {
				let imei = localStorage.getItem('imei')
				let predate = ''
				if (this.$route.query.t) {
					predate = parseInt(this.$route.query.t)/1000;
				}
				data_tag(imei, predate).then(res => {
					this.datestr = res.date;
					let colors = [{
							n: '愤怒',
							c: '3',
							s: '因极度不满而情绪激动和感到生气'
						}, {
							n: '恼怒',
							c: '3',
							s: '生气、发怒'
						}, {
							n: '反感',
							c: '2',
							s: '反对或不满的情绪'
						}, {
							n: '疏离感',
							c: '2',
							s: '不喜欢，或兴趣不大。产生了孤独感、寂寞感、自我隔离、无意识感等的情感变化'
						}, {
							n: '绝望',
							c: '2',
							s: '缺少希望，一般指对某种事物或人完全失去了信心'
						}, {
							n: '暴躁',
							c: '2',
							s: '情绪急躁，无法控制感情，容易发火'
						}, {
							n: '气愤',
							c: '2',
							s: '生气、愤恨'
						}, {
							n: '忧虑',
							c: '2',
							s: '是由对还未发生事情的担心引起的，表现为提心吊胆和无安全感'
						}, {
							n: '消极',
							c: '2',
							s: '更关注事情的负面信息，逃避现实，意志消沉'
						}, {
							n: '凄凉',
							c: '2',
							s: '孤寂冷落'
						},
						{
							n: '惊讶',
							c: '2',
							s: '感到意外，是出现超出我们预先设想的东西时的一种内心体验'
						}, {
							n: '紧张',
							c: '2',
							s: '精神处于高度准备状态,不松弛'
						}, {
							n: '平静',
							c: '1',
							s: '感受不到外界的骚扰，没有动荡，心情平和安静'
						}, {
							n: '松懈',
							c: '1',
							s: '注意力不集中，精神懈怠'
						}, {
							n: '疲乏',
							c: '2',
							s: '出现体力、精力明显的减退，不想做某些事情或在做的过程当中不能坚持'
						}, {
							n: '喜庆',
							c: '1',
							s: '感觉到有值得高兴或值得庆贺的事情'
						}, {
							n: '快乐',
							c: '1',
							s: '一种高兴或满意的心态'
						}, {
							n: '欣然',
							c: '1',
							s: '非常愉快的，自然的（指表情上的）高兴的样子'
						}, {
							n: '安宁',
							c: '1',
							s: '心情安定平静'
						}, {
							n: '镇静',
							c: '1',
							s: '心情平稳、冷静，从容不迫，不烦恼'
						},
						{
							n: '狂喜',
							c: '1',
							s: '极端高兴，欣喜若狂'
						}, {
							n: '兴奋',
							c: '1',
							s: '因高兴或受某种刺激而精神激奋'
						}, {
							n: '满足',
							c: '1',
							s: '当某事物已经符合预期，感到已经足够和满意'
						}, {
							n: '安心',
							c: '1',
							s: '安定的心情，没有烦恼，有安全感'
						}, {
							n: '安详',
							c: '1',
							s: '稳重且沉静，从容不迫'
						}, {
							n: '休眠',
							c: '1',
							s: '因体力、脑力消耗过多而感到难以支持，需要休息'
						}
					]
					if (res.data.length < 1) {
						return;
					}
					for (let i in colors) {
						if (res.data[0].affect == colors[i].n) {
							this.affectImg = 'emobj' + colors[i].c + '.png'
							this.affectStr = colors[i].s
							this.affectTag = colors[i].n
						}
					}
					if (this.affectTag == '休眠') {
						this.affectTag == '疲惫'
					}
					this.wxshare()
					this.nickname = localStorage.getItem('nickname') || ''
					let uploadate = {
						dayMean: this.dayMean,
						predayMean: this.predayMean,
						percet: this.dayPercent,
						affectTag: this.affectTag,
						affectImg: this.affectImg,
						affectStr: this.affectStr,
						date: this.datestr,
						nickname: this.nickname,
						emoup: this.emoup,
						emodn: this.emodn,
						triup: this.triup,
						tridn: this.tridn,
						strup: this.strup,
						strdn: this.strdn,
						emoStable: this.emoStable,
						tirStable: this.tirStable,
						strStable: this.strStable,
						dayEmotionTimeln: this.dayEmotionTimeln
					}
					this.querydata = JSON.stringify(uploadate)
					let imei = localStorage.getItem('imei')
					let phone = localStorage.getItem('phone')
					upload_tag(uploadate, imei, predate, phone)
				})
			}
		},
		created() {
			this.nickname = localStorage.getItem('nickname') || ''
			console.log(this.$route.query.data);
			if (this.$route.query.data) {
				this.showdayMean = true;
				this.querydata = this.$route.query.data
				let data = JSON.parse(this.$route.query.data)
				this.datestr = data.date;
				this.affectImg = data.affectImg
				this.affectStr = data.affectStr
				this.affectTag = data.affectTag
				this.emoup = data.emoup;
				this.emodn = data.emodn;
				this.triup = data.triup;
				this.tridn = data.tridn;
				this.strup = data.strup;
				this.strdn = data.strdn;
				this.emoStable = data.emoStable;
				this.tirStable = data.tirStable;
				this.strStable = data.strStable;
				this.dayEmotionTimeln = data.dayEmotionTimeln;
				console.log("created this.affectTag");
				console.log(this.affectTag);
				this.swipeDot.push({
					active: false
				})
				this.swipeDot.push({
					active: false
				})
				this.swipeDot.push({
					active: false
				})
				this.swipeDot.push({
					active: false
				})
				this.swipeDot.push({
					active: false
				})
				let emoImg = ''
				let triImg = ''
				let strImg = ''
				this.dayMean = data.dayMean
				this.dayPercent = data.percet
				this.predayMean = data.predayMean
				let dayMean = data.dayMean
				if (dayMean.emotion <= 49) {
					emoImg = 'emobj3.png'
				} else if (dayMean.emotion >= 50 && dayMean.emotion <= 69) {
					emoImg = 'emobj5.png'
				} else if (dayMean.emotion >= 70 && dayMean.emotion <= 100) {
					emoImg = 'emobj1.png'
				}
				if (dayMean.tired <= 49) {
					triImg = 'emobj1.png'
				} else if (dayMean.tired >= 50 && dayMean.tired <= 69) {
					triImg = 'emobj2.png'
				} else if (dayMean.tired >= 70 && dayMean.tired <= 100) {
					triImg = 'emobj3.png'
				}
				if (dayMean.stress <= 49) {
					strImg = 'emobj1.png'
				} else if (dayMean.stress >= 50 && dayMean.stress <= 69) {
					strImg = 'emobj2.png'
				} else if (dayMean.stress >= 70 && dayMean.stress <= 100) {
					strImg = 'emobj3.png'
				}
				this.swipeList = [{
					str: '今日心情',
					img: emoImg,
					active: true
				}, {
					str: '今日压力',
					img: strImg,
					active: false
				}, {
					str: '今日疲劳',
					img: triImg,
					active: false
				}]
				return true;
			}


			let d = new Date();
			// this.datestr = `${d.getFullYear()}/${d.getMonth()+1}/${d.getDate()}`
			let phone = localStorage.getItem('phone')
			let times = 1665540675;
			// let times = 1666770637;
			let second = parseInt(d.getTime() / 1000)
			this.loading = false;
			if (this.$route.query.t) {
				second = parseInt(this.$route.query.t) / 1000;
			}
			choice_day_data(phone, second).then(res => {

				// choice_day_data(phone, times).then(res => {
				// this.getTag()
				this.loading = true;
				if (res.status == 200) {
					let today = res.data.today
					if (today.length < 1) {
						return this.$toast('暂无数据');
					}
					this.emoup = res.data.emoup;
					this.emodn = res.data.emodn;
					this.triup = res.data.triup;
					this.tridn = res.data.tridn;
					this.strup = res.data.strup;
					this.strdn = res.data.strdn;
					this.emoStable = res.data.emoStable;
					this.tirStable = res.data.tirStable;
					this.strStable = res.data.strStable;
					this.getTag()
					this.today = res.data.today
					this.preday = res.data.preday
					let dayEmotionSum = 0;
					let dayEmotionLn = 0;
					let dayTiredSum = 0;
					let dayTiredLn = 0;
					let dayStressSum = 0;
					let dayStressLn = 0;
					let dayEmotionA = 0;
					let dayEmotionB = 0;
					let dayEmotionC = 0;
					let dayStressA = 0;
					let dayStressB = 0;
					let dayStressC = 0;
					let dayTiredA = 0;
					let dayTiredB = 0;
					let dayTiredC = 0;
					this.dayEmotionTimeln = 0;
					res.data.today.forEach(item => {
						if (item.emotion != -1) {
							this.dayEmotionTimeln += 1;
							dayEmotionSum += item.emotion;
							dayEmotionLn += 1;
							if (item.emotion >= 0 && item.emotion <= 49) {
								dayEmotionA += 1
							}
							if (item.emotion >= 50 && item.emotion <= 69) {
								dayEmotionB += 1
							}
							if (item.emotion >= 70 && item.emotion <= 100) {
								dayEmotionC += 1
							}
						}
						if (item.tired != -1) {
							dayTiredSum += item.tired;
							dayTiredLn += 1;
							if (item.tired >= 0 && item.tired <= 49) {
								dayTiredA += 1
							}
							if (item.tired >= 50 && item.tired <= 69) {
								dayTiredB += 1
							}
							if (item.tired >= 70 && item.tired <= 100) {
								dayTiredC += 1
							}
						}
						if (item.stress != -1) {
							dayStressSum += item.stress;
							dayStressLn += 1
							if (item.stress >= 0 && item.stress <= 49) {
								dayStressA += 1
							}
							if (item.stress >= 50 && item.stress <= 69) {
								dayStressB += 1
							}
							if (item.stress >= 70 && item.stress <= 100) {
								dayStressC += 1
							}
						}
					})

					let dayEmotionAll = dayEmotionA + dayEmotionB + dayEmotionC
					let dayStressAll = dayStressA + dayStressB + dayStressC
					let dayTiredAll = dayTiredA + dayTiredB + dayTiredC
					this.dayMean.emotion = parseInt(dayEmotionSum / dayEmotionLn)
					this.dayMean.tired = parseInt(dayTiredSum / dayTiredLn)
					this.dayMean.stress = parseInt(dayStressSum / dayStressLn)
					this.dayPercent.emotion = [Math.round(dayEmotionC / dayEmotionAll * 100), Math.round(
							dayEmotionB / dayEmotionAll * 100), Math.round(dayEmotionA / dayEmotionAll * 100)]
						.sort(sortv)
					this.dayPercent.tired = [Math.round(dayTiredC / dayTiredAll * 100), Math.round(dayTiredB /
						dayTiredAll * 100), Math.round(dayTiredA / dayTiredAll * 100)].sort(sortv)
					this.dayPercent.stress = [Math.round(dayStressC / dayStressAll * 100), Math.round(dayStressB /
						dayStressAll * 100), Math.round(dayStressA / dayStressAll * 100)].sort(sortv)
					this.dayPercentAll.emotion = [{
						value: dayEmotionC
					}, {
						value: dayEmotionB
					}, {
						value: dayEmotionA
					}]
					this.dayPercentAll.stress = [{
						value: dayStressC
					}, {
						value: dayStressB
					}, {
						value: dayStressA
					}]
					this.dayPercentAll.tired = [{
						value: dayTiredC
					}, {
						value: dayTiredB
					}, {
						value: dayTiredA
					}]
					let predayEmotionSum = 0;
					let predayEmotionLn = 0;
					let predayTiredSum = 0;
					let predayTiredLn = 0;
					let predayStressSum = 0;
					let predayStressLn = 0;
					res.data.preday.forEach(item => {
						if (item.emotion != -1) {
							predayEmotionSum += item.emotion;
							predayEmotionLn += 1;
						}
						if (item.tired != -1) {
							predayTiredSum += item.tired;
							predayTiredLn += 1;
						}
						if (item.stress != -1) {
							predayStressSum += item.stress;
							predayStressLn += 1
						}
					})
					this.predayMean.emotion = parseInt(predayEmotionSum / predayEmotionLn)
					this.predayMean.tired = parseInt(predayTiredSum / predayTiredLn)
					this.predayMean.stress = parseInt(predayStressSum / predayStressLn)
					let emoImg = ''
					let triImg = ''
					let strImg = ''
					let dayMean = this.dayMean
					if (dayMean.emotion <= 49) {
						emoImg = 'emobj3.png'
					} else if (dayMean.emotion >= 50 && dayMean.emotion <= 69) {
						emoImg = 'emobj5.png'
					} else if (dayMean.emotion >= 70 && dayMean.emotion <= 100) {
						emoImg = 'emobj1.png'
					}
					if (dayMean.tired <= 49) {
						triImg = 'emobj1.png'
					} else if (dayMean.tired >= 50 && dayMean.tired <= 69) {
						triImg = 'emobj2.png'
					} else if (dayMean.tired >= 70 && dayMean.tired <= 100) {
						triImg = 'emobj3.png'
					}
					if (dayMean.stress <= 49) {
						strImg = 'emobj1.png'
					} else if (dayMean.stress >= 50 && dayMean.stress <= 69) {
						strImg = 'emobj2.png'
					} else if (dayMean.stress >= 70 && dayMean.stress <= 100) {
						strImg = 'emobj3.png'
					}

					this.swipeList = [{
						str: '今日心情',
						img: emoImg,
						active: true
					}, {
						str: '今日压力',
						img: strImg,
						active: false
					}, {
						str: '今日疲劳',
						img: triImg,
						active: false
					}]
					this.swipeDot.push({
						active: false
					})
					this.swipeDot.push({
						active: false
					})
					this.swipeDot.push({
						active: false
					})
					this.swipeDot.push({
						active: false
					})
					if (this.dayMean['emotion'] > 0) {
						this.showdayMean = true;
						this.swipeDot.push({
							active: false
						})
					}

				}
			}).catch(() => {
				this.loading = true;
			})
		}
	}

	function sortv(a, b) {
		return b - a;
	}

	function copyUrl(url) {
		var input = document.createElement('input');
		document.body.appendChild(input);
		input.setAttribute('value', url);
		input.select();
		document.execCommand("copy");
		if (document.execCommand('copy')) {
			document.execCommand('copy');
			Toast({
				message: '链接复制成功',
				position: 'bottom',
			});
		}
		document.body.removeChild(input);
	}

	function randomRange(min, max) {
		return Math.floor(Math.random() * (max - min)) + min;
	}

	function identifyTip(i, val) {
		let emoupA = [`发现您最近一段时间内的心情状态为：${val} 心情愉悦！`, `主人，您最近一段时间的心情指数为： ${val} 心情愉悦。`,
			`哇哦，您最近一段时间的心情不错哦：  ${val} 心情愉悦。`
		]
		let emoupB = [`在这段时间里，您的心情非常愉快!`, `您的心情指数为${val}，喜上眉梢，心情很棒哦~`,
			`，您的心情指数为${val}，现在的您可以更灵活机智地处理问题，行动上也更加果断利落`
		]
		let emoupC = [`可以利用当下这种积极的心态投入重要的事情中，平时觉得较困难的任务在这个时候处理可以取得较良好的效果。`, `良好的心情有利于进行与人打交道的活动哦~`,
			`一个能控制好自己情绪的人，在生活还是事业上会有很大的发展机遇。`
		]
		let emonpA = [`发现您的心情不太好，很担心您呢: ${val} 情绪低落`, `主人，您最近一段时间的心情指数为：${val} 情绪低落`]
		let emonpB = [`这段时间里您心情不太好呢，长时间处于负面情绪可能会导致生活和工作积极性下降`,
			`我感觉到您在的心情可能不是很好，人们在面临问题和不可控因素时就会引发糟糕的情绪反应`
		]
		let emonpC = [`生活方面换个角度思考问题，便会豁然开朗，建议保持随遇而安的心态`, `遇事要保持理智冷静，尽量不要自己先乱了阵脚，处理不来时不妨请教别人`]
		let triedupA = [`您最近这段时间内的疲劳指数达到：${val} 十分疲劳`, `我发现您最近的疲劳程度有些高： ${val} 十分疲劳`]
		let triedupB = [`这段时间里疲劳程度较大，可能伴随着思考问题速度变慢，反映迟钝的状态。`,
			`在您非常劳累，可能出现情绪低落、百无聊赖的感受`
		]
		let triedupC = [`疲劳感多来自于用脑过度，建议在状态不佳时尝试出去走走`, `您的效率会出现显著降低，建议立即暂停当前活动，一段时间后再回来继续`]
		let triednpA = [`您今天时间内的疲劳指数为：${val} 精力充沛`, `主人，您最近的疲劳指数为：${val} 精力充沛`]
		let triednpB = [`在您的精力十足`, `在这段时间内您精神状态良好，元气满满`]
		let triednpC = [`状态非常优秀，利用好当前充沛的精力投入到重要的事情可做到事半功倍`, `可以投入精力去做比较复杂和困难的事情哦~`]
		let stressupA = [`主人，您最近的压力程度有些大了呢： ${val} 压力较大`, `发现您最近的压力较大：${val} 压力较大`]
		let stressupB = [`在您的压力很大，压力会由生活中一些重大事件或者累积的烦心琐事引发`,
			`您的状况有较大的起伏，可能发生了令你感到紧张焦虑或兴奋的事情`
		]
		let stressupC = [`您需要暂时让自己休整，找到适合自己的减压方式，可以尝试呼吸练习、冥想放松的方法`, `请尝试调整身心状态，如采用“2-4呼吸法”，即用鼻子吸气两秒，再用嘴缓慢呼气四秒，四次为一组`]
		let stressnpA = [`主人，您最近较为放松哦~ ${val} 非常放松`, `我发现您身心感到轻松呢：${val} 非常放松`]
		let stressnpB = [`在您心理压力水平较低，这种状态能够帮助身体从紧张状态恢复`,
			`在压力较小，工作会比较轻松，生活中也不会有让您感到为难的场景`
		]
		let stressnpC = [`如果是在工作和学习间隙压力较低，可以尽可能放松哦，日常生活中也请继续保持良好的生活和运动习惯`, `压力小总体上有利于身心健康，但如果长期处于低压，则也会使身体和大脑处于松懈状态`]
		let content = '';
		switch (i) {
			case 0:
				content = emoupA[randomRange(0, emoupA.length)]
				break;
			case 1:
				content = emonpA[randomRange(0, emonpA.length)]
				break;
			case 2:
				content = triedupA[randomRange(0, triedupA.length)]
				break;
			case 3:
				content = triednpA[randomRange(0, triednpA.length)]
				break;
			case 4:
				content = triednpA[randomRange(0, stressupA.length)]
				break;
			case 5:
				content = stressnpA[randomRange(0, stressnpA.length)]
				break;
		}
		return content
	}
</script>

<style>
	.container {
		background: linear-gradient(137deg, #E2FEFF 0%, #F4FFF8 100%);
		min-height: 100vh;
		/* max-width: 400px; */
		user-select:none;
		-webkit-touch-callout: none !important;
		-webkit-user-select: none;
	}

	.datemotionBj {
		height: 393px;
		position: relative;
		width: 355px;
		background-repeat: no-repeat;
		margin: 0 auto;
	}

	/* 	.ortherbj{
		background-image: url(https://www.qingxusuanfa.com/public/emobj4.png);
	} */
	.p-white {
		font-size: 18px;
		line-height: 32px;
	}

	.p-black {
		font-size: 18px;
		color: #333333;
		line-height: 32px;
	}

	.p-min {
		font-size: 14px;
		color: #969696;
	}

	.p-mina {
		font-size: 14px;
		color: #969696;
		line-height: 29px;
	}

	.p-minb {
		font-size: 14px;
		color: #969696;
		line-height: 32px;
	}

	.head {
		/* display: flex; */
		flex-direction: row;
		justify-content: space-between;
		font-size: 16px;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		align-items: center;
	}

	.share {
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 180px;
	}

	/* 	.share-box {
		width: 352px;
		height: 100px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: center;
		border-radius: 20px 20px 20px 20px;
		background: #F8FFFB;
	} */

	.s-itme {
		margin: 10px 40px;
		width: 66px;
		height: 80px;
	}

	.s-itme img {
		width: 48px;
		height: 48px;
		margin-left: 9px;
	}

	.empty img {
		position: relative;
		top: 40px;
		display: block;
		width: 120px;
		height: 120px;
		margin: 0 auto;
	}

	.empty-text {
		position: relative;
		top: 40px;
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		text-align: center;
		color: #999;
		font-weight: 500;
	}

	.s-itme>p {
		width: 65px;
		height: 18px;
		font-size: 13px;
		font-weight: 500;
		color: #575757;
		line-height: 18px;
		-webkit-background-clip: text;
		text-align: center;
	}

	.share-canel {
		height: 48px;
		border-radius: 20px 20px 20px 20px;
		margin-top: 10px;
		line-height: 48px;
		font-size: 15px;
		font-weight: 500;
		color: #575757;
	}
	.block {
		width: 120px;
		height: 120px;
		background-color: #fff;
	}

	.my-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		text-align: center;
	}

	.emobj {
		z-index: 0;
		width: 355px;
		height: 393px;
		position: absolute;
		left: 10px;
	}

	.emobj1 {
		background-image: url('../assets/images/emobj1.png');
	}

	.emobj2 {
		background-image: url('../assets/images/emobj2.png');
	}

	.emobj3 {
		background-image: url('../assets/images/emobj3.png');
	}

	.emoblock {
		margin: 0 auto;
		top: 70px;
		width: 300px;
		line-height: 45px;
		z-index: 1;
		position: relative;
		color: #ffff00;
		text-align: left;
	}

	.emocontent {
		color: #FFFFFF;
		padding-top: 115px;
		z-index: 1;
		position: relative;
	}

	.custom-indicator {
		width: 100%;
		height: 5px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.custom-indicator div {
		width: 10px;
		height: 5px;
		background: #D9D9D9;
		border-radius: 6px 6px 6px 6px;
		margin: 0 2px;
	}

	.custom-indicator .active {
		width: 20px;
		height: 5px;
		background: #0DCAC3;
		border-radius: 6px 6px 6px 6px;
		margin: 0 2px;
	}
	.logotxt{
		width: 150px;height: 64px;margin-left: 20px;font-weight: 500;color: #333333;line-height: 24px;
	}
	.logotxt>div{
		color:#000;font-size: 16px;
	}
	.logoblock{
		display: flex;flex-direction: row;justify-content: space-between;width: 343px;height: 64px;margin: 10px auto;
	}
	.dateimgmain{
		margin: 0 auto;
		width: 343px;
		height: 379px;
		background-repeat: no-repeat;
	}
	.imgtitle{
		text-align: left;width: 320px;margin: 10px auto;
		font-size: 18px;
		font-weight: bold;
		color: #08070E;
		line-height: 18px;
	}
/* 	p {
		color: #FFFFFF;
	} */
</style>
